var render = function render(){var _vm=this,_c=_vm._self._c;return _c('flat-pickr',{staticClass:"theme-custom form-control",attrs:{"modelValue":_vm.value,"input-id":_vm.inputId,"placeholder":_vm.placeholder,"disabled":_vm.disabled,"inline":_vm.inline,"invalid-feedback":_vm.invalidFeedback,"state":_vm.state,"config":_vm.config,"type":"datetime","input-class":"form-control"},on:{"update:modelValue":_vm.onChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }